import { WhiteLabelAssetMinimal } from 'api/brand/schema';
import { FC } from 'react';
import { TrashOutline } from 'react-ionicons';

interface AttachmentProps {
  file: File | null;
  uploadedFile: WhiteLabelAssetMinimal | null;
  onCancel: () => void;
}

const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 B';

  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
};

const Attachment: FC<AttachmentProps> = ({ file, onCancel, uploadedFile }) => {
  return (
    <div className="min-w-full space-y-4 rounded bg-neutral-500 bg-opacity-[8%] p-4 shadow-[0px_4px_8px_0px_rgba(0,_0,_0,_0.16)]">
      <div className="flex justify-between gap-4">
        <div className="flex w-24 flex-col gap-1">
          <p className="truncate text-xs font-semibold  text-content-base-default">
            {uploadedFile?.asset_name ?? file?.name}
          </p>
          <div className="flex gap-2 text-xs font-semibold text-content-base-subdued">
            <p className="truncate">
              {formatFileSize(uploadedFile?.file_size ?? file?.size ?? 0)}
            </p>
          </div>
        </div>
        {uploadedFile?.id ? (
          <div className="text-content-base-default" onClick={onCancel}>
            <TrashOutline width="20px" height="20px" color="currentColor" />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Attachment;
